import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { jsx as _jsx } from "react/jsx-runtime";
export const PageResultsCount = ({
  total,
  pageSize,
  page,
  searchCriteria
}) => {
  const {
    isMobile
  } = useMediaQuery();
  if (!total) {
    if (searchCriteria) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.errors.filters.noResultsFound"
      });
    }
    return null;
  }
  const searchTerm = (() => {
    if (searchCriteria !== null && searchCriteria !== void 0 && searchCriteria.search) {
      return searchCriteria.search;
    }
    if (searchCriteria !== null && searchCriteria !== void 0 && searchCriteria.category) {
      const {
        category
      } = searchCriteria;
      if (isValidI18nKey(`learningCenter.topFilters.cat.${category}`)) {
        return I18n.text(`learningCenter.topFilters.cat.${category}`);
      }
    }
    if (searchCriteria !== null && searchCriteria !== void 0 && searchCriteria.hubspotSoftware) {
      const {
        hubspotSoftware
      } = searchCriteria;
      if (isValidI18nKey(`learningCenter.topFilters.tools.${hubspotSoftware}`)) {
        return I18n.text(`learningCenter.topFilters.tools.${hubspotSoftware}`);
      }
    }
  })();
  const startCard = page * pageSize + 1;
  const endCard = Math.min(page * pageSize + pageSize, total);
  return isMobile ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.myLearning.totalResultsCount",
    options: {
      cardsTotal: total
    }
  }) : searchTerm ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.myLearning.paginatedSearchResultsCount",
    options: {
      startCard,
      endCard,
      cardsTotal: total,
      searchTerm
    }
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.myLearning.paginatedResultsCount",
    options: {
      startCard,
      endCard,
      cardsTotal: total
    }
  });
};